// src/DashboardEntry.jsx
import { Navigate } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import Dashboard from "./pages/Dashboard";

export default function DashboardEntry() {
  const { usuario, loading } = useAuth();
  if (loading) return null;

  if (usuario?.rol === "ADMIN") {
    return <Navigate to="/admin/colegiados" replace />;
  }
  return <Dashboard />;
}
